import ShippingStagesEnum from "../../../../../enums/ShippingStagesEnum";

export const shippingStatus = Object.entries(ShippingStagesEnum).map(([key, value]) => {
    return {
        label: value.message,
        value: value.id
    };
});

export const findShippingLabel = (id) => {
    const status = shippingStatus.find((status) => status.value === id);
    return status ? status.label : "";
};